import { render, staticRenderFns } from "./ParallaxSection.vue?vue&type=template&id=712c1f54&"
import script from "./ParallaxSection.vue?vue&type=script&lang=ts&"
export * from "./ParallaxSection.vue?vue&type=script&lang=ts&"
import style0 from "./ParallaxSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports